// extracted by mini-css-extract-plugin
export var details = "_g8-0";
export var inspectorPopover = "_g8-1";